import axios from "@/plugins/axios";

export default {
    actions: {
        fetchSaleServiceDailyStat(context, searchItem) {
            let url = "sale_service_dailies?page="  + searchItem.page

            if (!context.state.saleServiceDailyStat.isNeedFetch && !searchItem.isNeedFetch) {
                return
            }

            if (searchItem.byAmount) {
                url = url + '&order[amount]=desc'
            } else {
                url = url + '&order[incomeAmount]=desc'
            }

            if (searchItem.before) {
                url = url + '&date[before]=' + searchItem.before
            }

            if (searchItem.after) {
                url = url + '&date[after]=' + searchItem.after
            }

            return axios.get(url)
                .then((response) => {
                    console.log(response)

                    let data = {
                        models: response.data['hydra:member'],
                        totalItems: response.data['hydra:totalItems']
                    }

                    context.commit('updateSaleServiceDailyStat', data)
                })
                .catch((err) => {
                    console.log(err)
                })
        },
    },
    mutations: {
        updateSaleServiceDailyStat(state, data) {
            state.saleServiceDailyStat = data
            state.saleServiceDailyStat.isNeedFetch = false
        },
    },
    state: {
        saleServiceDailyStat: {
            models: [],
            totalItems: 0,
            isNeedFetch: true
        },
    },
    getters: {
        getSaleServiceDailyStat(state) {
            return state.saleServiceDailyStat.models
        },
        getSaleServiceDailyStatTotalCount(state) {
            return state.saleServiceDailyStat.totalItems
        },
    },
}
